import Vue from 'vue'
import axiosInst from '../../libs/axios/axios'
import moment from 'moment-timezone'
const _ = require('lodash')

const state = {
  rootUrl: process.env.VUE_APP_ROOT_URL,
  timeOut: process.env.VUE_APP_TIME_OUT,
  currentQueryParameter: [],
  timePackage: {},
  chartsData:{
    temp:{
      insideTemp:[],
      outsideTemp:[],
      categories: [],
      max: 40,
      min: 0
    },
    hum:{
      insideHum:[],
      outsideHum:[],
      categories: []
    }
  },
  outsideTemperatureAndHumidityData: []
}
const getters = {
  returnCurrentQueryParameterAnalytics (state) {
    return state.currentQueryParameter
  },
  tempAndHumChartData (state) {
    return state.chartsData
  }
}
const mutations = {
  chartsData (state, info) {
    state.chartsData = {
      temp:{
        insideTemp:[],
        outsideTemp:[],
        categories: [],
        max: 40,
        min: 0
      },
      hum:{
        insideHum:[],
        outsideHum:[],
        categories: []
      }
    }

    const temp = state.chartsData.temp
    const hum = state.chartsData.hum
    const temp_weatherapi_labels = []
    const hum_weatherapi_labels = []
  

    if (info.temp) {
      info.temp.map((value, index) => {
        temp.insideTemp.push(Number(value.avg_temp))
        temp.categories.push(moment.tz(value.binned_timestamp, 'Greenwich').tz('Europe/Istanbul').format())
        temp_weatherapi_labels.push(new Date(moment.tz(value.binned_timestamp, 'Greenwich').tz('Europe/Istanbul').format()).getTime() / 1000)
        if (index + 1 === info.temp.length) {
          temp.min = Math.min(...temp.insideTemp) - 5
  
          if (Math.max(...temp.insideTemp) > temp.max) {
            temp.max = Math.max(...temp.insideTemp)
          }
          if (Math.min(...temp.insideTemp) > 32) {
            temp.min = 30
          }
          
          if (state.outsideTemperatureAndHumidityData.length > 0) {
            const temp_data = state.outsideTemperatureAndHumidityData
            temp_weatherapi_labels.map((value, index) => {
              const day_date = moment(value * 1000).format('YYYY-MM-DD')
              const dayIndex = _.findLastIndex(temp_data, function (val) { return val.date === day_date })
  
              if (dayIndex !== -1) {
                const day = temp_data[dayIndex]
                if (state.timePackage.bucket === '24h' || state.timePackage.bucket === '96h' || state.timePackage.bucket === '7d') {
                  temp.outsideTemp[index] = day.temperature ? day.temperature : null
                } else {
                  const hourIndex = _.findLastIndex(day ? day.hour : [], function (val) { return val.time_epoch === value })
                  if (hourIndex !== -1) {
                    temp.outsideTemp[index] = day.hour[hourIndex].temperature ? day.hour[hourIndex].temperature : null
                  } else {
                    temp.outsideTemp[index] = null
                  }
                }
              } else {
                temp.outsideTemp[index] = null
              }
            })
          }
        }
      })
    }

    if (info.hum) {
      info.hum.map((value, index) => {
        hum.insideHum.push(Number(value.avg_hum))
        hum.categories.push(moment.tz(value.binned_timestamp, 'Greenwich').tz('Europe/Istanbul').format())
        hum_weatherapi_labels.push(new Date(moment.tz(value.binned_timestamp, 'Greenwich').tz('Europe/Istanbul').format()).getTime() / 1000)
        if (index + 1 === info.hum.length) {
          if (state.outsideTemperatureAndHumidityData.length > 0) {
            const hum_data = state.outsideTemperatureAndHumidityData
            hum_weatherapi_labels.map((value, index) => {
              const day_date = moment(value * 1000).format('YYYY-MM-DD')
              const dayIndex = _.findLastIndex(hum_data, function (val) { return val.date === day_date })

              if (dayIndex !== -1) {
                const day = hum_data[dayIndex]
                if (state.timePackage.bucket === '24h' || state.timePackage.bucket === '96h' || state.timePackage.bucket === '7d') {
                  hum.outsideHum[index] = day.humidity ? day.humidity : null
                } else {
                  const hourIndex = _.findLastIndex(day ? day.hour : [], function (val) { return val.time_epoch === value })
                  if (hourIndex !== -1) {
                    hum.outsideHum[index] = day.hour[hourIndex].humidity ? day.hour[hourIndex].humidity : null
                  } else {
                    hum.outsideHum[index] = null
                  }
                }
              } else {
                hum.outsideHum[index] = null
              }
            })
          }
        }
      })
    }

  },
  currentQueryParameter (state, info) {
    state.currentQueryParameter[info.index] = info.value
    Vue.set(state.currentQueryParameter, info.index, info.value)
  },
  timePackage (state, info) {
    state.timePackage = info
  },
  outsideTemperatureAndHumidityData (state, info) {
    state.outsideTemperatureAndHumidityData = info
  }
}
const actions = {
  currentQueryParameter (store, currentQueryParameter) {
    if (currentQueryParameter.index === 1) {
      const timePackage = {
        bucket: ''
      }

      const start_date = moment(currentQueryParameter.value[0])
      const end_date = moment(currentQueryParameter.value[1])
      const difference = end_date.diff(start_date, 'days')

      if (difference < 8) {
        timePackage.bucket = '2h'
      } else if (difference >= 8 && difference < 12) {
        timePackage.bucket = '3h'
      } else if (difference >= 12 && difference < 16) {
        timePackage.bucket = '4h'
      } else if (difference >= 16 && difference < 30) {
        timePackage.bucket = '6h'
      } else if (difference >= 30 && difference < 120) {
        timePackage.bucket = '24h'
      } else if (difference >= 120 && difference < 365) {
        timePackage.bucket = '96h'
      } else if (difference >= 365) {
        timePackage.bucket = '7d'
      }

      store.commit('timePackage', timePackage)
    }
    store.commit('currentQueryParameter', currentQueryParameter)
  },
  async getChartData (store) {
    try {
      const start_date = moment(state.currentQueryParameter[1][0]).utc().format('YYYY-MM-DD HH:mm:ss')
      const end_date = moment(state.currentQueryParameter[1][1]).utc().format('YYYY-MM-DD HH:mm:ss')
      
      const response = await axiosInst.get(`${state.rootUrl  }/api/hives/${  state.currentQueryParameter[0]  }/timeseries/?start_timestamp=${  start_date  }&end_timestamp=${  end_date  }&time_bucket=${  state.timePackage.bucket  }`)
      
      store.commit('chartsData', response.data.timeseries_data)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getOutsideTemperatureAndHumidityData (store) {
    return new Promise((resolve, reject) => {
      const start_date = moment(state.currentQueryParameter[1][0]).utc().format('YYYY-MM-DD')
      const end_date = moment(state.currentQueryParameter[1][1]).utc().format('YYYY-MM-DD')
      axiosInst.get(`${state.rootUrl  }/api/apiary/${  state.currentQueryParameter[4]  }/weather/${  start_date  }/${  end_date  }/`)
        .then(response => {
          store.commit('outsideTemperatureAndHumidityData', response.data.weather_list)
          resolve(response)
        })
        .catch(error => {
          store.commit('outsideTemperatureAndHumidityData', [])
          reject(error)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
